const routes = [
    {
        path: "/staff/id/card",
        component: () => import("../pages/Index.vue"),
        permission:'staffcard_staffcards'
    }
];

export default routes;
